import { EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { addAnalytics } from '../../../analytics/utils';
export var firePromptConfigNotFoundError = function firePromptConfigNotFoundError(_ref) {
  var editorView = _ref.editorView,
    dispatch = _ref.dispatch,
    prompt = _ref.prompt,
    adjustSelection = _ref.adjustSelection,
    promptText = _ref.promptText;
  var errorEventTr = addAnalytics({
    editorState: editorView.state,
    tr: editorView.state.tr,
    payload: {
      action: 'error',
      actionSubject: 'editorPluginAI',
      actionSubjectId: 'eventHubPlugin',
      attributes: {
        errorType: 'promptConfigItemNotFound',
        prompt: prompt,
        promptText: promptText,
        adjustSelection: adjustSelection
      },
      eventType: EVENT_TYPE.OPERATIONAL
    }
  });
  dispatch(errorEventTr);
};